import { StateCreator } from 'zustand';

export interface DirtyGuard {
    checkDirty: () => boolean;
    save: () => Promise<boolean>;
    discard: () => void;
}

export interface DirtyGuardSlice {
    guard: DirtyGuard | null;
    registerDirtyGuard: (guard: DirtyGuard) => void;
    clearDirtyGuard: () => void;
    isCurrentPageDirty: () => boolean;
}

export const createDirtyGuardSlice: StateCreator<DirtyGuardSlice> = (set, get) => ({
    guard: null,

    registerDirtyGuard: (guard) => set({ guard }),

    clearDirtyGuard: () => set({ guard: null }),

    isCurrentPageDirty: () => {
        const { guard } = get();
        return guard ? guard.checkDirty() : false;
    }
});
